import { useCallback, useEffect, useState } from 'react';
import { SIDEBAR_STORAGE_KEY } from '../config/navigation/navigation.constants';
import { SIDEBAR_WIDTH } from '../features/app-shell/constants/appShell.constants';

function readStoredCollapsed() {
  try {
    return localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export default function useSidebarState() {
  const [collapsed, setCollapsed] = useState(readStoredCollapsed);

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_STORAGE_KEY, String(collapsed));
    } catch {
      // ignore storage errors
    }
  }, [collapsed]);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const setCollapsedState = useCallback((value) => {
    setCollapsed(Boolean(value));
  }, []);

  const width = collapsed ? SIDEBAR_WIDTH.collapsed : SIDEBAR_WIDTH.expanded;

  return {
    collapsed,
    width,
    toggleCollapsed,
    setCollapsed,
    setCollapsedState,
  };
}
